import { useMemo } from 'react';
import { ApprovalStatus, TApproval } from '@modules/approvals';
import { getLatestVersionId } from '@modules/items';

/**
 * Determines whether a given version is editable.
 * Editable when viewing the draft, or the latest version with no pending/approved approval.
 */
const useIsVersionEditable = (
  versionId: string,
  item: { draft?: unknown; versions: { id: string }[]; approvals: TApproval[] }
): boolean =>
  useMemo(() => {
    if (versionId === 'draft') return true;
    const latest = getLatestVersionId(item);
    if (versionId !== latest) return false;
    return item.approvals.every(
      (a) => a.versionId !== versionId || [ApprovalStatus.CANCELED, ApprovalStatus.DECLINED].includes(a.status)
    );
  }, [versionId, item]);

export default useIsVersionEditable;
